import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import enCommon from './locales/en/common.json';
import enPages from './locales/en/pages.json';
import enErrors from './locales/en/errors.json';
import enPermissions from './locales/en/permissions.json';
import enNotifications from './locales/en/notifications.json';
import enComponents from './locales/en/components.json';

import ptBRCommon from './locales/pt-BR/common.json';
import ptBRPages from './locales/pt-BR/pages.json';
import ptBRErrors from './locales/pt-BR/errors.json';
import ptBRPermissions from './locales/pt-BR/permissions.json';
import ptBRNotifications from './locales/pt-BR/notifications.json';
import ptBRComponents from './locales/pt-BR/components.json';

import esCommon from './locales/es/common.json';
import esPages from './locales/es/pages.json';
import esErrors from './locales/es/errors.json';
import esPermissions from './locales/es/permissions.json';
import esNotifications from './locales/es/notifications.json';
import esComponents from './locales/es/components.json';

// Available languages
export const languages = [
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'pt-BR', name: 'Portuguese (Brazil)', nativeName: 'Portugues (Brasil)' },
  { code: 'es', name: 'Spanish', nativeName: 'Espanol' },
] as const;

export type LanguageCode = typeof languages[number]['code'];

  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources: {
        en: {
          common: enCommon,
          pages: enPages,
          errors: enErrors,
          permissions: enPermissions,
          notifications: enNotifications,
          components: enComponents,
        },
        'pt-BR': {
          common: ptBRCommon,
          pages: ptBRPages,
          errors: ptBRErrors,
          permissions: ptBRPermissions,
          notifications: ptBRNotifications,
          components: ptBRComponents,
        },
        es: {
          common: esCommon,
          pages: esPages,
          errors: esErrors,
          permissions: esPermissions,
          notifications: esNotifications,
          components: esComponents,
        },
      },
      fallbackLng: 'en',
      defaultNS: 'common',
      ns: ['common', 'pages', 'errors', 'permissions', 'notifications', 'components'],
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      // Order of language detection
      order: ['localStorage', 'navigator'],
      // Cache user language in localStorage
      caches: ['localStorage'],
      lookupLocalStorage: 'language',
    },
  });

export default i18n;
